import React from 'react';
import { Box, Collapse } from '@chakra-ui/react';
import { useReducedMotion } from 'framer-motion';
import useDashboardMetrics from '../../hooks/useDashboardMetrics';
import useCurrentUser from '../../hooks/useCurrentUser';
import { useDashboardExpand } from './DashboardExpandContext';
import DashboardBento from './DashboardBento';

// item 258 — the expanded dashboard bento, rendered in NORMAL PAGE FLOW directly below
// the sticky KPI strip (NOT inside the pinned sticky stack). Expanding it pushes the
// routed page content down and the whole page scrolls as one document — it no longer
// floats as a semi-transparent layer the page slides under. Driven by the shared
// expand context so the strip's chevron controls it. Financial roles only (item 102).
const DashboardBentoSlot: React.FC = () => {
  const { open } = useDashboardExpand();
  const { hasFinancialAccess } = useCurrentUser();
  const reduceMotion = useReducedMotion();
  const m = useDashboardMetrics();

  if (!hasFinancialAccess) return null;

  if (reduceMotion) {
    return open ? (
      <Box mb={{ base: 3, md: 4 }}>
        <DashboardBento m={m} />
      </Box>
    ) : null;
  }

  return (
    <Collapse in={open} animateOpacity>
      <Box mb={{ base: 3, md: 4 }}>
        <DashboardBento m={m} />
      </Box>
    </Collapse>
  );
};

export default DashboardBentoSlot;
